export default __webpack_public_path__ + "static/media/cart.307f68cf.svg";